import React from 'react';
import { Button, Card, Dimmer, Grid, Icon, Form } from 'tabler-react';
import Input from '../../Components/Playgrond/Input';
import fetch from '../../support/fetch';
import CardAlert from '../CardAlert';
import Modal from 'react-responsive-modal';

import './index.css';
import { Link } from 'react-router-dom';

class CreditCardInfo extends React.Component {

    state = {
        showLoader: true,
        showForm: false,
        creditCard: null,
        subscriptions: [],
        alertText: null,
        openModal: false,
        alertColor: 'danger',
        values: {},
        feedback: {
            number: {
                text: "Somente números, sem espaços",
                state: 'normal',
                show: true
            },
            holder_name: {
                text: "Nome impresso no cartão",
                state: 'normal',
                show: false
            },
            expiration_month: {
                text: "Mês com dois dígitos",
                state: 'normal',
                show: true
            },
            expiration_year: {
                text: "Ano com quatro dígitos",
                state: 'normal',
                show: true
            },
            security_code: {
                text: "três dígitos atrás do cartão",
                state: 'normal',
                show: true
            },
        }
    };

    componentDidMount() {
        this.fetchData();
    };

    /**
     * Set value to feedback object.
     *
     * @param key
     * @param show
     * @param text
     * @param state
     */
    setFeedbackState(key, show, text, state) {
        this.setState(prevState => ({
            feedback: {
                ...prevState.feedback,
                [key]: {
                    show: show,
                    text: text,
                    state: state
                }
            }
        }))
    }

    /**
     * Validate form inputs.
     *
     * @returns {boolean}
     */
    validate = () => {
        const requiredFields = ['holder_name', 'number', 'expiration_month', 'expiration_year'];
        const filled = requiredFields.every(item =>
            this.state.values.hasOwnProperty(item) && this.state.values[item] !== ''
        );

        if (!filled) {
            return false;
        }

        const expirationYear = `${this.state.values.expiration_year || ''}`;

        if (expirationYear.length !== 4) {
            this.setFeedbackState(
                'expiration_year',
                true,
                'Informe o ano com 4 dígitos.',
                'error'
            );
            return false;
        }

        return true;
    };

    /**
     * Fetch actual credit card related with the user.
     */
    fetchData = () => {
        fetch.obj({
            query: `query FetchCreditCardInfo {
                creditCard {
                    number
                    expiration_month
                    expiration_year
                }
                subscriptions (status: ACTIVATED) {
                    data {
                        id
                        status
                    }
                }
            }`
        })
        .then(res => {
            // if (!res.data.hasOwnProperty('creditCard')) {
            //     // @todo: implement a error logic here...
            // }

            this.setState({
                creditCard: res.data.creditCard,
                subscriptions: res.data.subscriptions.data,
                showLoader: false
            });
        });
    };


    addNewCreditCard = () => {

       
        const card = window.PagSeguro.encryptCard({
            publicKey: process.env.REACT_APP_ENCRYPT_PAGSEGURO,
            holder:this.state.values.holder_name,
            number:this.state.values.number,
            expMonth: this.state.values.expiration_month,
            expYear: this.state.values.expiration_year,
            securityCode:  this.state.values.security_code
        });

        const encrypted_card = card.encryptedCard;
        const hasErrors = card.hasErrors;
        const errors = card.errors;

        if(hasErrors) {
            const newState = {
                showLoader: false
            };

            this.setState(newState);

            alert("Informações de cartão inválidas, por favor, verifique os dados do seu cartão.", );

            console.log(errors);
            
            return;
        }
    

        fetch.obj({
            query: `mutation AddNewCreditCard (
                $holder_name: String!,
                $number: String!
                $expiration_month: String!
                $expiration_year: String!
                $security_code: String!
                $encrypted_card: String!
            ) {
                addNewCreditCard(
                    holder_name: $holder_name
                    number: $number
                    expiration_month: $expiration_month
                    expiration_year: $expiration_year
                    security_code: $security_code
                    encrypted_card: $encrypted_card
                ) {
                    number
                    expiration_month
                    expiration_year
                }
            }`,
            variables: {
                holder_name: this.state.values.holder_name,
                number: this.state.values.number,
                expiration_month: this.state.values.expiration_month,
                expiration_year: this.state.values.expiration_year,
                security_code: this.state.values.security_code,
                encrypted_card: encrypted_card
            }
        })
        .then(res => {
            if (res.hasOwnProperty('errors') && res.errors[0].hasOwnProperty('validation')) {
                Object.keys(res.errors[0].validation).forEach((item, i) => {
                    this.setFeedbackState(item, true, res.errors[0].validation[item][0], 'error');
                });
            }

            if (res.hasOwnProperty('errors') && !res.errors[0].hasOwnProperty('validation')) {
                this.setState({
                    alertText: "Erro durante o salvamento do cartão, verifique seu endereço. É importante que o estado esteja em formato de Siglas."
                });
            }

            const newState = {
                showLoader: false
            };

            if (res.data.hasOwnProperty('addNewCreditCard') && res.data.addNewCreditCard) {
                newState.creditCard = res.data.addNewCreditCard;
                newState.showForm = false;
                newState.alertColor = 'success';
                newState.alertText = 'Parabéns, seu cartão foi inserido com sucesso.';
                newState.openModal = true;
            }

            this.setState(newState, () => {
                setTimeout(() => {
                        this.setState({
                            alertText: null
                        })
                    },
                    5000
                )
            });
        });
    };

    /**
     * Show current credit card info.
     *
     * @returns {XML}
     */
    information = () => {
        const { creditCard } = this.state;

        return (
            <Grid.Col>
                <Grid.Row>
                    <Grid.Col width={8}>
                        <h6 className="mb-0">Número do Cartão</h6>
                        <span className="lead">
                        { creditCard && creditCard.number}
                    </span>
                    </Grid.Col>

                    <Grid.Col width={4}>
                        <h6 className="mb-0">Vencimento</h6>
                        <span className="lead">
                            {creditCard && creditCard.expiration_month}/
                            {creditCard && creditCard.expiration_year}
                        </span>
                    </Grid.Col>
                </Grid.Row>
            </Grid.Col>
        );
    };

    /**
     * Non credit card is present.
     *
     * @returns {XML}
     */
    insertNewCreditCard = (hasActiveSubscriptions = false) => {

        const naoPerca = <p className="lead text-center mb-0">
                            Não perca a chance de ser visto.<br />
                            Cadastre um novo cartão de crédito e 
                            mantenha a sua assinatura sempre ativa.
                        </p>

        return (
            <Grid.Col>
                { hasActiveSubscriptions && 
                    naoPerca
                }
                { !hasActiveSubscriptions && this.props.fromHome &&
                    <p className="lead text-justify mb-0">    
                    Só é possível adicionar um novo cartão se houver uma assinatura ATIVA, 
                    caso você não tenha nenhuma assinatura ativa é necessário criar uma 
                    nova assinatura.
                    </p>
                }
                { !hasActiveSubscriptions && !this.props.fromHome &&
                    naoPerca
                }
            </Grid.Col>
        );
    };



    /**
     * Store fields values to state.
     *
     * @param e
     */
    onChangeHandler = e => {
        const { name, value } = e.target;

        this.setState(prevState => ({
            values: {
                ...prevState.values,
                [name]: value
            }
        }), () => {
            if (name === 'expiration_year') {
                if (value.length === 0) {
                    this.setFeedbackState('expiration_year', true, 'Ano com quatro dígitos', 'normal');
                } else if (value.length === 4) {
                    this.setFeedbackState('expiration_year', true, 'Ano com quatro dígitos', 'success');
                } else {
                    this.setFeedbackState('expiration_year', true, 'Informe o ano com 4 dígitos.', 'error');
                }
            }
        })
    };

    /**
     * Insert new credit card form.
     *
     * @returns {XML}
     */
    creditCardForm = () => {
        return (
            <React.Fragment>
                <Grid.Col width="12">
                    <Form.Group label="Número do Cartão">
                        <Input
                            name="number"
                            type="tel"
                            maxLength={30}
                            state={this.state.feedback.number.state}
                            feedbackText={this.state.feedback.number.text}
                            showFeedbackText={this.state.feedback.number.show}
                            required
                            numberOnly
                            onChange={this.onChangeHandler}
                        />
                    </Form.Group>
                </Grid.Col>

                <Grid.Col width="12">
                    <Form.Group label="Nome no Cartão">
                        <Input
                            name="holder_name"
                            type="text"
                            maxLength={30}
                            required
                            pipe={v => v.toUpperCase()}
                            onChange={this.onChangeHandler}
                            state={this.state.feedback.holder_name.state}
                            feedbackText={this.state.feedback.holder_name.text}
                            showFeedbackText={this.state.feedback.holder_name.show}
                        />
                    </Form.Group>
                </Grid.Col>

                <Grid.Col width="6">
                    <Form.Group label="Mês de Expiração">
                        <Input
                            name="expiration_month"
                            type="tel"
                            maxLength={2}
                            numberOnly
                            required
                            state={this.state.feedback.expiration_month.state}
                            feedbackText={this.state.feedback.expiration_month.text}
                            showFeedbackText={this.state.feedback.expiration_month.show}
                            onChange={this.onChangeHandler}
                        />
                    </Form.Group>
                </Grid.Col>

                <Grid.Col width="6">
                    <Form.Group label="Ano de Expiração">
                        <Input
                            name="expiration_year"
                            type="tel"
                            numberOnly
                            maxLength={4}
                            required
                            state={this.state.feedback.expiration_year.state}
                            feedbackText={this.state.feedback.expiration_year.text}
                            showFeedbackText={this.state.feedback.expiration_year.show}
                            onChange={this.onChangeHandler}
                        />
                    </Form.Group>
                </Grid.Col>

                <Grid.Col width="6">
                    <Form.Group label="Código de Segurança">
                        <Input
                            name="security_code"
                            type="tel"
                            numberOnly
                            maxLength={3}
                            required
                            state={this.state.feedback.security_code.state}
                            feedbackText={this.state.feedback.security_code.text}
                            showFeedbackText={this.state.feedback.security_code.show}
                            onChange={this.onChangeHandler}
                        />
                    </Form.Group>
                </Grid.Col>
            </React.Fragment>
        );
    };

    /**
     * Show the add new credit card form.
     *
     * @param e
     */
    showForm = (e) => {
        this.setState({showForm: true})
    };

    /**
     * Hide the add new credit card form.
     * @param e
     */
    hideForm = (e) => {
        this.setState({showForm: false})
    };

    /**
     * Submit form.
     *
     * @param e
     */
    submitHandler = e => {
        this.setState({
            showLoader: true
        });

        if (! this.validate()) {
            this.setState({
                alertText: 'Por favor, preencha corretamente o formulário.',
                alertColor: 'danger'
            });
            this.setState({
                showLoader: false
            });
            return;
        }

        this.addNewCreditCard();

       
    };

    onCloseModal = () => {
        this.setState({openModal: false});
    }



    /**
     * Render.
     *
     * @returns {XML}
     */
    render() {

        const { creditCard } = this.state;
        const activeSubscriptions = this.state.subscriptions;
        let hasActiveSubscription = false;
        if (activeSubscriptions.length > 0) {
            hasActiveSubscription = true;
        }
        //let showFooterButton = false;
        let showFooterButton = true;
        //if (hasActiveSubscription || !this.props.fromHome) {
        //    showFooterButton = true;
        //}

        const content = this.state.showForm === false
            ? (creditCard ? this.information() : this.insertNewCreditCard(hasActiveSubscription))
            : this.creditCardForm();

        const submitButton = this.state.showForm === false
            ? <Button pill outline size="sm" color="info" onClick={this.showForm}>Cadastrar Cartão</Button>
            : <Button.List align="left">
                <Button pill outline size="sm" color="success" onClick={this.submitHandler}>Salvar Novo Cartão</Button>
                <button className="btn" onClick={this.hideForm}>cancel</button>
            </Button.List>;

        return (
            <Card className="credt-card-info">

                <Card.Body>
                    <div className="mb-0 text-center" style={{fontSize: '36px', lineHeight: '12px'}}>
                        <Icon name="credit-card" />
                    </div>
                    <h3 className="text-center mt-0">
                        Cartão de Crédito
                    </h3>
                </Card.Body>

                <CardAlert color={this.state.alertColor}>{this.state.alertText}</CardAlert>

                <Card.Body>
                    <Dimmer loader={true} active={this.state.showLoader}>
                        <Grid.Row>
                            { content }
                        </Grid.Row>
                    </Dimmer>
                </Card.Body>

                {
                    !this.state.showLoader &&
                    <Card.Footer className="text-center">
                        { showFooterButton && submitButton}
                    </Card.Footer>
                }

                <Modal open={this.state.openModal} center onClose = {this.onCloseModal} >
                    <div className='modal-wrapper'>
                        <p>Cartão atualizado com sucesso ! Saca só :</p>
                        <ul>
                            <li>Caso você tenha uma ASSINATURA ATIVA, o cartão será utilizado automaticamente para os proximos pagamentos.</li>
                            <li>Se você ja tem um plano ativo e deseja trocar de plano, cancele a assinatura atual clicando <Link to="/subscriptions">aqui</Link> e escolha a proxima assinatura.</li>
                            <li>Caso ja esteja sem uma assinatura, basta ir diretamente escolher seu novo plano clicando <Link to="/subscriptions/new">aqui</Link>.</li>
                            <li>Se você estiver regularizando seu pagamento e quer voltar a estar ativo na plataforma, cancele a assinatura suspensa/atrasada, clicando <Link to="/subscriptions">aqui</Link> e depois crie uma nova assinatura</li>
                        </ul>
                    </div>
                </Modal>
            </Card>
        );
    }
}

export default CreditCardInfo;
